import { InstanceLink } from '~/components/Details/InstanceDetails/MenuInstances';
import { ObjectLiteral } from '~/types/generics';

import { IProcessFile, IProcessXmlFormFieldParsed } from '../processes/types';
import { IGroup, IUser } from '../users/types';

export enum ITaskTypes {
  CHANGE_TASKS_FILTER_REQUEST = '@tasks/CHANGE_TASKS_FILTER_REQUEST',

  GET_TASKS_REQUEST = '@tasks/GET_TASKS_REQUEST',
  GET_TASKS_SUCCESS = '@tasks/GET_TASKS_SUCCESS',
  GET_TASKS_FAILURE = '@tasks/GET_TASKS_FAILURE',

  GET_COMPLETED_TASKS_REQUEST = '@tasks/GET_COMPLETED_TASKS_REQUEST',
  GET_COMPLETED_TASKS_SUCCESS = '@tasks/GET_COMPLETED_TASKS_SUCCESS',
  GET_COMPLETED_TASKS_FAILURE = '@tasks/GET_COMPLETED_TASKS_FAILURE',

  GET_DELETED_TASKS_REQUEST = '@tasks/GET_DELETED_TASKS_REQUEST',
  GET_DELETED_TASKS_SUCCESS = '@tasks/GET_DELETED_TASKS_SUCCESS',
  GET_DELETED_TASKS_FAILURE = '@tasks/GET_DELETED_TASKS_FAILURE',

  GET_TASKS_HISTORY_ALL_REQUEST = '@tasks/GET_TASKS_HISTORY_ALL_REQUEST',
  GET_TASKS_HISTORY_ALL_SUCCESS = '@tasks/GET_TASKS_HISTORY_ALL_SUCCESS',
  GET_TASKS_HISTORY_ALL_FAILURE = '@tasks/GET_TASKS_HISTORY_ALL_FAILURE',

  GET_TASKS_HISTORY_COUNT_REQUEST = '@tasks/GET_TASKS_HISTORY_COUNT_REQUEST',
  GET_TASKS_HISTORY_COUNT_SUCCESS = '@tasks/GET_TASKS_HISTORY_COUNT_SUCCESS',
  GET_TASKS_HISTORY_COUNT_FAILURE = '@tasks/GET_TASKS_HISTORY_COUNT_FAILURE',

  GET_TASK_REQUEST = '@tasks/GET_TASK_REQUEST',
  GET_TASK_SUCCESS = '@tasks/GET_TASK_SUCCESS',
  GET_TASK_FAILURE = '@tasks/GET_TASK_FAILURE',

  GET_TASK_HISTORY_REQUEST = '@tasks/GET_TASK_HISTORY_REQUEST',
  GET_TASK_HISTORY_SUCCESS = '@tasks/GET_TASK_HISTORY_SUCCESS',
  GET_TASK_HISTORY_FAILURE = '@tasks/GET_TASK_HISTORY_FAILURE',

  RESET_TASK_ASSIGNED_ERROR = '@tasks/RESET_TASK_ASSIGNED_ERROR',

  CLAIM_TASK_REQUEST = '@tasks/CLAIM_TASK_REQUEST',
  CLAIM_TASK_SUCCESS = '@tasks/CLAIM_TASK_SUCCESS',
  CLAIM_TASK_FAILURE = '@tasks/CLAIM_TASK_FAILURE',

  UNCLAIM_TASK_REQUEST = '@tasks/UNCLAIM_TASK_REQUEST',
  UNCLAIM_TASK_SUCCESS = '@tasks/UNCLAIM_TASK_SUCCESS',
  UNCLAIM_TASK_FAILURE = '@tasks/UNCLAIM_TASK_FAILURE',

  GET_TASK_FORM_REQUEST = '@tasks/GET_TASK_FORM_REQUEST',
  GET_TASK_FORM_SUCCESS = '@tasks/GET_TASK_FORM_SUCCESS',
  GET_TASK_FORM_FAILURE = '@tasks/GET_TASK_FORM_FAILURE',

  GET_TASK_FORM_HTML_REQUEST = '@tasks/GET_TASK_FORM_HTML_REQUEST',
  GET_TASK_FORM_HTML_SUCCESS = '@tasks/GET_TASK_FORM_HTML_SUCCESS',
  GET_TASK_FORM_HTML_FAILURE = '@tasks/GET_TASK_FORM_HTML_FAILURE',

  GET_TASK_FORM_VARIABLES_REQUEST = '@tasks/GET_TASK_FORM_VARIABLES_REQUEST',
  GET_TASK_FORM_VARIABLES_SUCCESS = '@tasks/GET_TASK_FORM_VARIABLES_SUCCESS',
  GET_TASK_FORM_VARIABLES_FAILURE = '@tasks/GET_TASK_FORM_VARIABLES_FAILURE',

  EXECUTE_TASK_REQUEST = '@tasks/EXECUTE_TASK_REQUEST',
  EXECUTE_TASK_SUCCESS = '@tasks/EXECUTE_TASK_SUCCESS',
  EXECUTE_TASK_FAILURE = '@tasks/EXECUTE_TASK_FAILURE',

  GET_HISTORY_TASK_REQUEST = '@tasks/GET_HISTORY_TASK_REQUEST',
  GET_HISTORY_TASK_SUCCESS = '@tasks/GET_HISTORY_TASK_SUCCESS',
  GET_HISTORY_TASK_FAILURE = '@tasks/GET_HISTORY_TASK_FAILURE',

  GET_TASK_DATA_CHART_REQUEST = '@tasks/GET_TASK_DATA_CHART_REQUEST',
  GET_TASK_DATA_CHART_SUCCESS = '@tasks/GET_TASK_DATA_CHART_SUCCESS',
  GET_TASK_DATA_CHART_FAILURE = '@tasks/GET_TASK_DATA_CHART_FAILURE',

  GET_TASKS_STATUS_REQUEST = '@tasks/GET_TASKS_STATUS_REQUEST',
  GET_TASKS_STATUS_SUCCESS = '@tasks/GET_TASKS_STATUS_SUCCESS',
  GET_TASKS_STATUS_FAILURE = '@tasks/GET_TASKS_STATUS_FAILURE',

  GET_CANCELING_REASONS_REQUEST = '@tasks/GET_CANCELING_REASONS_REQUEST',
  GET_CANCELING_REASONS_SUCCESS = '@tasks/GET_CANCELING_REASONS_SUCCESS',
  GET_CANCELING_REASONS_FAILURE = '@tasks/GET_CANCELING_REASONS_FAILURE',

  GET_TASK_RANKING_REQUEST = '@tasks/GET_TASK_RANKING_REQUEST',
  GET_TASK_RANKING_SUCCESS = '@tasks/GET_TASK_RANKING_SUCCESS',
  GET_TASK_RANKING_FAILURE = '@tasks/GET_TASK_RANKING_FAILURE',

  GET_TASK_LIST_BY_PROCESS_INSTANCE_REQUEST = '@tasks/GET_TASK_LIST_BY_PROCESS_INSTANCE_REQUEST',
  GET_TASK_LIST_BY_PROCESS_INSTANCE_SUCCESS = '@tasks/GET_TASK_LIST_BY_PROCESS_INSTANCE_SUCCESS',
  GET_TASK_LIST_BY_PROCESS_INSTANCE_FAILURE = '@tasks/GET_TASK_LIST_BY_PROCESS_INSTANCE_FAILURE',

  GET_FILTER_PARAMS_REQUEST = '@tasks/GET_FILTER_PARAMS_REQUEST',
  GET_FILTER_PARAMS_SUCCESS = '@tasks/GET_FILTER_PARAMS_SUCCESS',
  GET_FILTER_PARAMS_FAILURE = '@tasks/GET_FILTER_PARAMS_FAILURE',

  IS_EXECUTING_TASK_REQUEST = '@tasks/IS_EXECUTING_TASK_REQUEST',

  CLEAR_FILTER_PARAMS_REQUEST = '@tasks/CLEAR_FILTER_PARAMS_REQUEST',
  CLEAR_SEARCH_FILTER_REQUEST = '@tasks/CLEAR_SEARCH_FILTER_REQUEST',
}

export enum TaskColor {
  PURPLE = '#671966',
  ROSE = '#EB0045',
  DARK_GREY = '#A19C9B',
  RED = '#EA0000',
  ORANGE = '#FF8000',
  GREY = '#E6E6E6',
  DARK_RED = '#99002E',
  LIGHT_PINK = '#FF99B8',
}

export enum TaskStatusName {
  TASKS_AVAILABLE = 'Disponíveis',
  TASKS_ASSIGNED = 'Atribuídas',
  TASKS_COMPLETED = 'Concluídas',
  TASKS_DELETED = 'Excluídas',
  TASKS_DELAYED = 'Atrasadas',
  TASKS_EXPIRING = 'Próximas a vencer',
  TASKS_ON_TIME = 'No prazo',
  TASKS_CANCELED = 'Canceladas',
}

export enum TaskInstanceStatus {
  ON_TIME = 'No prazo',
  EXPIRING = 'Próximo a vencer',
  OVERDUE = 'Atrasadas',
}

export interface IChangeTasksFilterRequestAction {
  type: typeof ITaskTypes.CHANGE_TASKS_FILTER_REQUEST;
  payload: {
    filter: 'unassigned' | 'assignee' | 'assigneeNotIn' | 'finished';
  };
}

export interface IGetTasksRequestAction {
  type: typeof ITaskTypes.GET_TASKS_REQUEST;
  payload: {
    params: IGetTasksParams;
    user: IUser;
  };
}
export interface IGetTasksSuccessAction {
  type: typeof ITaskTypes.GET_TASKS_SUCCESS;
  payload: {
    sortOrder: 'asc' | 'desc';
    tasks: ITask[];
    count: ITaskInstanceCount;
  };
}
export interface IGetTasksFailureAction {
  type: typeof ITaskTypes.GET_TASKS_FAILURE;
}

export interface IGetCompletedTasksRequestAction {
  type: typeof ITaskTypes.GET_COMPLETED_TASKS_REQUEST;
  payload: {
    params: any;
    changeOrder: boolean;
  };
}
export interface IGetCompletedTasksSuccessAction {
  type: typeof ITaskTypes.GET_COMPLETED_TASKS_SUCCESS;
  payload: {
    sortOrder: 'asc' | 'desc';
    completedTasks: ITaskHistory[];
    totalCompletedTasks: number;
  };
}
export interface IGetCompletedTasksFailureAction {
  type: typeof ITaskTypes.GET_COMPLETED_TASKS_FAILURE;
}

export interface IGetDeletedTasksRequestAction {
  type: typeof ITaskTypes.GET_DELETED_TASKS_REQUEST;
  payload: {
    params: any;
    changeOrder: boolean;
  };
}
export interface IGetDeletedTasksSuccessAction {
  type: typeof ITaskTypes.GET_DELETED_TASKS_SUCCESS;
  payload: {
    sortOrder: 'asc' | 'desc';
    deletedTasks: ITaskHistory[];
    totalDeletedTasks: number;
  };
}
export interface IGetDeletedTasksFailureAction {
  type: typeof ITaskTypes.GET_DELETED_TASKS_FAILURE;
}

export interface IGetTasksHistoryAllRequestAction {
  type: typeof ITaskTypes.GET_TASKS_HISTORY_ALL_REQUEST;
  payload: {
    params: any;
    changeOrder: boolean;
  };
}
export interface IGetTasksHistoryAllSuccessAction {
  type: typeof ITaskTypes.GET_TASKS_HISTORY_ALL_SUCCESS;
  payload: {
    sortOrder: 'asc' | 'desc';
    tasksHistoryAll: ITaskHistory[];
    totalTasksHistoryAll: number;
  };
}
export interface IGetTasksHistoryAllFailureAction {
  type: typeof ITaskTypes.GET_TASKS_HISTORY_ALL_FAILURE;
}

export interface IGetTasksHistoryCountRequestAction {
  type: typeof ITaskTypes.GET_TASKS_HISTORY_COUNT_REQUEST;
}
export interface IGetTasksHistoryCountSuccessAction {
  type: typeof ITaskTypes.GET_TASKS_HISTORY_COUNT_SUCCESS;
  payload: {
    totalTasksHistory: string;
  };
}
export interface IGetTasksHistoryCountFailureAction {
  type: typeof ITaskTypes.GET_TASKS_HISTORY_COUNT_FAILURE;
}

export interface IResetTaskAssignedError {
  type: typeof ITaskTypes.RESET_TASK_ASSIGNED_ERROR;
}

export interface IUnclaimTaskRequestAction {
  type: typeof ITaskTypes.UNCLAIM_TASK_REQUEST;
  payload: {
    taskIds: Array<string>;
    getTasksParams: IGetTasksRequestAction['payload'];
  };
}
export interface IUnclaimTaskSuccessAction {
  type: typeof ITaskTypes.UNCLAIM_TASK_SUCCESS;
}
export interface IUnclaimTaskFailureAction {
  type: typeof ITaskTypes.UNCLAIM_TASK_FAILURE;
  payload: {
    failures: Array<IFailure>;
  };
}

export interface IGetTaskRequestAction {
  type: typeof ITaskTypes.GET_TASK_REQUEST;
  payload: {
    id: string;
    executeTask?: boolean;
  };
}
export interface IGetTaskSuccessAction {
  type: typeof ITaskTypes.GET_TASK_SUCCESS;
  payload: {
    task: ITask;
    executeTask?: boolean;
  };
}
export interface IGetTaskFailureAction {
  type: typeof ITaskTypes.GET_TASK_FAILURE;
  payload: {
    errorStatus: number;
  };
}

export interface IClaimTaskRequestAction {
  type: typeof ITaskTypes.CLAIM_TASK_REQUEST;
  payload: {
    taskIds: Array<string>;
    userId: number;
    managerId: number;
    getTasksParams: IGetTasksRequestAction['payload'];
    reassignee?: true;
  };
}
export interface IClaimTaskSuccessAction {
  type: typeof ITaskTypes.CLAIM_TASK_SUCCESS;
}
export interface IClaimTaskFailureAction {
  type: typeof ITaskTypes.CLAIM_TASK_FAILURE;
  payload: {
    failures: Array<IFailure>;
  };
}

export interface IGetTaskFormRequestAction {
  type: typeof ITaskTypes.GET_TASK_FORM_REQUEST;
  payload: {
    task: ITask;
  };
}
export interface IGetTaskFormSuccessAction {
  type: typeof ITaskTypes.GET_TASK_FORM_SUCCESS;
  payload: {
    id: string;
    form: IProcessXmlFormFieldParsed[];
  };
}
export interface IGetTaskFormFailureAction {
  type: typeof ITaskTypes.GET_TASK_FORM_FAILURE;
  payload: {
    id: string;
  };
}

export interface IGetTaskFormHTMLRequestAction {
  type: typeof ITaskTypes.GET_TASK_FORM_HTML_REQUEST;
  payload: {
    id: string;
  };
}
export interface IGetTaskFormHTMLSuccessAction {
  type: typeof ITaskTypes.GET_TASK_FORM_HTML_SUCCESS;
  payload: {
    id: string;
    form: string;
  };
}
export interface IGetTaskFormHTMLFailureAction {
  type: typeof ITaskTypes.GET_TASK_FORM_HTML_FAILURE;
  payload: {
    id: string;
  };
}

export interface IGetTaskFormVariablesRequestAction {
  type: typeof ITaskTypes.GET_TASK_FORM_VARIABLES_REQUEST;
  payload: {
    id: string;
  };
}
export interface IGetTaskFormVariablesSuccessAction {
  type: typeof ITaskTypes.GET_TASK_FORM_VARIABLES_SUCCESS;
  payload: {
    id: string;
    formVariables: ObjectLiteral;
  };
}
export interface IGetTaskFormVariablesFailureAction {
  type: typeof ITaskTypes.GET_TASK_FORM_VARIABLES_FAILURE;
  payload: {
    id: string;
  };
}

export interface IExecuteTaskRequestAction {
  type: typeof ITaskTypes.EXECUTE_TASK_REQUEST;
  payload: {
    id: string;
    params: IGetTasksParams;
    user: IUser;
    variables: {
      [key: string]: any;
    };
    processFiles: IProcessFile[];
    rootProcessInstanceId?: string;
  };
}
export interface IExecuteTaskSuccessAction {
  type: typeof ITaskTypes.EXECUTE_TASK_SUCCESS;
  payload: {
    id: string;
  };
}
export interface IExecuteTaskFailureAction {
  type: typeof ITaskTypes.EXECUTE_TASK_FAILURE;
}

export interface IGetHistoryTaskRequestAction {
  type: typeof ITaskTypes.GET_HISTORY_TASK_REQUEST;
  payload: {
    id: string;
  };
}
export interface IGetHistoryTaskSuccessAction {
  type: typeof ITaskTypes.GET_HISTORY_TASK_SUCCESS;
  payload: {
    historyTask: ITaskHistory;
  };
}
export interface IGetHistoryTaskFailureAction {
  type: typeof ITaskTypes.GET_HISTORY_TASK_FAILURE;
}

export interface IGetTaskDataChartRequestAction {
  type: typeof ITaskTypes.GET_TASK_DATA_CHART_REQUEST;
  payload: {
    params?: ObjectLiteral;
  };
}
export interface IGetTaskDataChartSuccessAction {
  type: typeof ITaskTypes.GET_TASK_DATA_CHART_SUCCESS;
  payload: {
    tasksDataChart: ITaskData[];
  };
}
export interface IGetTaskDataChartFailureAction {
  type: typeof ITaskTypes.GET_TASK_DATA_CHART_FAILURE;
}

export interface IGetTasksStatusRequestAction {
  type: typeof ITaskTypes.GET_TASKS_STATUS_REQUEST;
  payload: {
    params?: ObjectLiteral;
  };
}
export interface IGetTasksStatusSuccessAction {
  type: typeof ITaskTypes.GET_TASKS_STATUS_SUCCESS;
  payload: {
    tasksStatusCount: ITaskData[];
  };
}
export interface IGetTasksStatusFailureAction {
  type: typeof ITaskTypes.GET_TASKS_STATUS_FAILURE;
}

export interface IGetCancelingReasonsRequestAction {
  type: typeof ITaskTypes.GET_CANCELING_REASONS_REQUEST;
  payload: {
    params?: ObjectLiteral;
  };
}
export interface IGetCancelingReasonsSuccessAction {
  type: typeof ITaskTypes.GET_CANCELING_REASONS_SUCCESS;
  payload: {
    cancelingReasons: ICancelingReasonData[];
  };
}
export interface IGetCancelingReasonsFailureAction {
  type: typeof ITaskTypes.GET_CANCELING_REASONS_FAILURE;
}

export interface IGetTaskRankingRequestAction {
  type: typeof ITaskTypes.GET_TASK_RANKING_REQUEST;
  payload: {
    params: ObjectLiteral;
  };
}
export interface IGetTaskRankingSuccessAction {
  type: typeof ITaskTypes.GET_TASK_RANKING_SUCCESS;
  payload: {
    taskRanking: ITaskRankingPosition[];
  };
}
export interface IGetTaskRankingFailureAction {
  type: typeof ITaskTypes.GET_TASK_RANKING_FAILURE;
}

export interface IGetTaskListByProcessInstanceRequestAction {
  type: typeof ITaskTypes.GET_TASK_LIST_BY_PROCESS_INSTANCE_REQUEST;
  payload: {
    processInstanceId: string;
  };
}
export interface IGetTaskListByProcessInstanceSuccessAction {
  type: typeof ITaskTypes.GET_TASK_LIST_BY_PROCESS_INSTANCE_SUCCESS;
  payload: {
    tasks: Array<InstanceLink>;
  };
}
export interface IGetTaskListByProcessInstanceFailureAction {
  type: typeof ITaskTypes.GET_TASK_LIST_BY_PROCESS_INSTANCE_FAILURE;
}

export interface IGetFilterParamsRequestAction {
  type: typeof ITaskTypes.GET_FILTER_PARAMS_REQUEST;
  payload: {
    filterParams: ObjectLiteral;
    searchFilter?: string;
  };
}

export interface IGetFilterParamsSuccessAction {
  type: typeof ITaskTypes.GET_FILTER_PARAMS_SUCCESS;
  payload: {
    filterParams: ObjectLiteral;
    searchFilter?: string;
  };
}

export interface IGetFilterParamsFailureAction {
  type: typeof ITaskTypes.GET_FILTER_PARAMS_FAILURE;
}

export interface IIsExecutingTaskRequestAction {
  type: typeof ITaskTypes.IS_EXECUTING_TASK_REQUEST;
}

export interface IClearFilterParamsRequestAction {
  type: typeof ITaskTypes.CLEAR_FILTER_PARAMS_REQUEST;
}

export interface IClearSearchFilterRequestAction {
  type: typeof ITaskTypes.CLEAR_SEARCH_FILTER_REQUEST;
}

export type ITaskActionsType =
  | IChangeTasksFilterRequestAction
  | IGetTasksRequestAction
  | IGetTasksSuccessAction
  | IGetTasksFailureAction
  | IGetCompletedTasksRequestAction
  | IGetCompletedTasksSuccessAction
  | IGetCompletedTasksFailureAction
  | IGetDeletedTasksRequestAction
  | IGetDeletedTasksSuccessAction
  | IGetDeletedTasksFailureAction
  | IGetTasksHistoryAllRequestAction
  | IGetTasksHistoryAllSuccessAction
  | IGetTasksHistoryAllFailureAction
  | IGetTasksHistoryCountRequestAction
  | IGetTasksHistoryCountSuccessAction
  | IGetTasksHistoryCountFailureAction
  | IResetTaskAssignedError
  | IClaimTaskRequestAction
  | IClaimTaskSuccessAction
  | IClaimTaskFailureAction
  | IUnclaimTaskRequestAction
  | IUnclaimTaskSuccessAction
  | IUnclaimTaskFailureAction
  | IGetTaskRequestAction
  | IGetTaskSuccessAction
  | IGetTaskFailureAction
  | IGetTaskFormRequestAction
  | IGetTaskFormSuccessAction
  | IGetTaskFormFailureAction
  | IGetTaskFormHTMLRequestAction
  | IGetTaskFormHTMLSuccessAction
  | IGetTaskFormHTMLFailureAction
  | IGetTaskFormVariablesRequestAction
  | IGetTaskFormVariablesSuccessAction
  | IGetTaskFormVariablesFailureAction
  | IExecuteTaskRequestAction
  | IExecuteTaskSuccessAction
  | IExecuteTaskFailureAction
  | IGetHistoryTaskRequestAction
  | IGetHistoryTaskSuccessAction
  | IGetHistoryTaskFailureAction
  | IGetTaskDataChartRequestAction
  | IGetTaskDataChartSuccessAction
  | IGetTaskDataChartFailureAction
  | IGetTasksStatusRequestAction
  | IGetTasksStatusSuccessAction
  | IGetTasksStatusFailureAction
  | IGetCancelingReasonsRequestAction
  | IGetCancelingReasonsSuccessAction
  | IGetCancelingReasonsFailureAction
  | IGetTasksStatusFailureAction
  | IGetTaskRankingRequestAction
  | IGetTaskRankingSuccessAction
  | IGetTaskRankingFailureAction
  | IGetTaskListByProcessInstanceRequestAction
  | IGetTaskListByProcessInstanceSuccessAction
  | IGetTaskListByProcessInstanceFailureAction
  | IGetFilterParamsRequestAction
  | IGetFilterParamsSuccessAction
  | IGetFilterParamsFailureAction
  | IIsExecutingTaskRequestAction
  | IClearFilterParamsRequestAction
  | IClearSearchFilterRequestAction;

export interface ITask {
  id: string;
  name: string;
  assignee: string;
  created: string;
  due: string;
  followUp: string;
  taskDefinitionKey: string;
  processDefinitionId: string;
  processDefinitionName: string;
  processDefinitionKey: string;
  processInstanceId: string;
  superProcessInstanceId: string;
  rootProcessInstanceId: string;
  processStartTime: string;
  nomeSolicitacao: string;
  nomeExecucao: string;
  registradoPorId: string;
  registradoPor: string;
  tenantId: string | null;
  status: 'Atrasada' | 'No prazo' | 'Próximo a vencer';
  userId: number;
  userName: string;
  vertical: string;
  assigneeName: string;
  users: IUser[];
  files: IProcessFile[];
  form: IProcessXmlFormFieldParsed[] | null;
  formHTML: string | null;
  formVariables: ObjectLiteral;
  variables: ObjectLiteral;
  state?: string;
  startTime: string;
  endTime: string;
  versionTag: string;
  candidateGroups: IGroup[];
  deleteReason: string;
  startableInTasklist?: boolean;
  dynamicTable: string;
}

export interface ITaskHistory {
  id: string;
  name: string;
  assignee: string;
  created: string;
  due: string;
  followUp: string;
  processDefinitionName: string;
  processInstanceId: string;
  nomeSolicitacao: string;
  nomeExecucao: string;
  registradoPorId: string;
  registradoPor: string;
  tenantId: string | null;
  status: string;
  startTime: string;
  endTime: string;
  vertical: string;
  assigneeName: string;
  files: IProcessFile[];
  processState?: string;
  processDefinitionVersion?: number;
  cancelingReason?: string;
  variables: ObjectLiteral;
  state: string | null;
  versionTag: string;
}

export interface ITaskData {
  name: string;
  value: number;
  color: string;
}

export interface ITaskInstanceCount {
  total: number;
  onTime: number;
  overdue: number;
}

export interface ICancelingReasonData {
  id: string;
  meta_value: string;
}

export interface ITaskRankingPosition {
  userId: string;
  finishedTasksCount: number;
  firstName: string;
  lastName: string;
}

export interface IFailure {
  id: string;
  errorType: string;
}

export enum DueDate {
  ON_TIME = 'noPrazoProximoAVencer',
  OVERDUE = 'atrasada',
}

export enum AssignedTo {
  ME = 'ME',
  OTHERS = 'OTHERS',
}

export type IGetTasksParams = {
  page: number;
  limit: number;
  sortBy: string;
  sortOrder: 'asc' | 'desc';

  assigned?: boolean;
  unassigned?: boolean;
  candidateGroups?: string[];
  includeAssignedTasks?: boolean;
  processDefinitionNames?: string[];
  assigneeIn?: string[];
  assigneeNotIn?: string[];
  endTime?: string[];
  taskSearch?: string;
  dueDate?: DueDate;
};

export type IFilterTaskParams = Omit<Partial<IGetTasksParams>, 'assigneeIn'> & {
  assigneeIn?: IUser[];
  assignedTo?: AssignedTo | null;
};

export interface ITaskState {
  readonly loading: boolean;
  readonly loadingTask: boolean;
  readonly loadingAssignee: boolean;
  readonly loadingExecution: boolean;
  readonly loadingTaskRanking: boolean;
  readonly loadingCancelingReasons: boolean;
  readonly loadingTaskDataChart: boolean;
  readonly loadingTasksByProcessInstance: boolean;

  readonly sortOrder: 'asc' | 'desc';

  readonly taskInstances: ITask[] | undefined;

  readonly tasksAssignedToMe: ITask[] | undefined;
  readonly tasksAssignedToOthers: ITask[] | undefined;
  readonly completedTasks: ITaskHistory[] | undefined;
  readonly deletedTasks: ITaskHistory[] | undefined;
  readonly tasksHistoryAll: ITaskHistory[] | undefined;
  readonly processTaskList: Array<InstanceLink>;

  task: ITask | undefined;
  historyTask: ITaskHistory | undefined;

  readonly countTasks: ITaskInstanceCount;

  readonly totalTasksHistory: number;
  readonly totalTasksHistoryAll: number;
  readonly totalCompletedTasks: number;
  readonly totalDeletedTasks: number;

  readonly isAvailable: boolean;
  readonly taskExecuted: boolean;
  readonly taskAssigned: boolean;
  readonly taskUnassigned: boolean;
  readonly taskAssignedError: boolean;
  readonly taskAssignedFailures: Array<IFailure>;

  readonly tasksDataChart: ITaskData[];
  readonly tasksStatusCount: ITaskData[];
  readonly taskRanking: ITaskRankingPosition[];

  readonly cancelingReasons: ICancelingReasonData[];

  readonly isExecutingTask: boolean;
  readonly filterParams: ObjectLiteral | undefined;
  readonly searchFilter: string | undefined;
  readonly errorStatus: number | undefined;
}
